import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ArrowWrap = styled.div`
  margin-top: 24px;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: flex-end;
  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
`;
